import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Stack, Typography } from "@mui/material";

import moment from "moment";
import { PdfIcon } from "components/Assets/generated";
import ImageIcon from "@mui/icons-material/Image";
import { downloadOnClick, viewDocument } from "utils/exportToExcel";

const Row = ({ row, i }) => {
  const handleExport = () => {
    // downloadOnClick(
    //   row?.documentUrl,
    //   `${new Date().getTime()}_${row.documentName}`
    // );
    viewDocument(
      row?.documentUrl,
    );
  };
  return (
    <TableRow
      sx={{
        mt: 1,
        "&:nth-of-type(odd)": {
          backgroundColor: "background.custom",
        },
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell align="left">{i + 1}</TableCell>
      <TableCell align="left">
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          {row?.documentName && row?.documentName?.includes(".pdf") ? (
            <PdfIcon />
          ) : (
            <ImageIcon />
          )}

          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              width: "180px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {row?.documentName}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell
        align="left"
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          opacity: 0.8,
        }}
      >
        {moment(new Date(row.createdAt)).format("MMM Do, YYYY")}{" "}
      </TableCell>

      <TableCell align="left">
        <Button
          variant="text"
          color="secondary"
          sx={{ fontSize: "0.8rem", textWrap: "nowrap" }}
          onClick={handleExport}
        >
          View document
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default function ImportedRecordsTable({ data }) {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left"></TableCell>
              <TableCell
                align="left"
                sx={{ fontWeight: "bold", textWrap: "nowrap" }}
              >
                Document Name
              </TableCell>
              <TableCell
                align="left"
                sx={{ fontWeight: "bold", textWrap: "nowrap" }}
              >
                Date Uploaded
              </TableCell>

              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, i) => (
              <Row key={row.id} row={row} i={i} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
